import { render, staticRenderFns } from "./PagosInstalacion.vue?vue&type=template&id=bf6c9c4c&"
import script from "./PagosInstalacion.vue?vue&type=script&lang=js&"
export * from "./PagosInstalacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports